import React from 'react';
import { Grid } from '@mui/material';

import { Typography, InfoField } from '@occc-app/design-system';
import { OfferFragment } from '@occc/graphql';

import { DateTimeFormat, formatDateTime, parseDate } from '../../../lib/date';

const dateFormatter = (value: string | null = null): string =>
  value ? formatDateTime(parseDate(value), DateTimeFormat.DateTime12h) : 'Date is not specified';

interface IPrimaryInformationProps {
  offer: OfferFragment;
}

export const PrimaryInformation: React.FC<IPrimaryInformationProps> = ({ offer }) => {
  return (
    <>
      <Typography variant='h6' component='h4' mb={3}>
        Primary Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item md={3}>
          <InfoField label='Name' value={offer?.name} />
        </Grid>
        <Grid item md={3}>
          <InfoField label='Category' value={offer?.category} />
        </Grid>
        <Grid item md={3}>
          <InfoField label='Created' value={dateFormatter(offer?.createdAt)} />
        </Grid>
        <Grid item md={3}>
          <InfoField label='Published' value={dateFormatter(offer?.publishAt)} />
        </Grid>
        <Grid item md={3}>
          <InfoField label='Description' value={offer?.description} />
        </Grid>
        <Grid item md={3}>
          <InfoField label='Expires' value={dateFormatter(offer?.expireAt)} />
        </Grid>
      </Grid>
    </>
  );
};
